export const handlePriceByComma = (price) => {
  return new Intl.NumberFormat("en-US").format(Math.floor(price));
};

/**
 * Round a price to the nearest whole number for display purposes only.
 * The raw (decimal) price is preserved for checkout / calculation;
 * only the visible text is rounded per customer request.
 *
 * @param {number|string} price
 * @returns {string} rounded whole-number string (e.g. 199.50 → "200")
 */
// The search index sends some prices as numeric strings, so never call toFixed on the raw value.
export const formatPriceFixed = (price, digits = 2) => {
  const num = Number(price);
  return Number.isFinite(num) ? num.toFixed(digits) : "";
};

export const roundPrice = (price) => {
  const num = Number(price);
  if (Number.isNaN(num)) return String(price);
  return String(Math.round(num));
};
